<template>
    <v-toolbar>
        <v-toolbar-title>Garage Door</v-toolbar-title>
        <v-spacer></v-spacer>
        <div>
            <v-btn style="margin-left:-2px;" flat icon color="black" @click="garageup()" >
                <v-icon medium>keyboard_arrow_up</v-icon>
            </v-btn>
            <v-btn style="margin-left:-2px;" flat icon color="black" @click="garagestop()" >
                <v-icon large>pause</v-icon>
            </v-btn>
            <v-btn style="margin-left:-2px;" flat icon color="black" @click="garagedown()" >
                <v-icon medium>keyboard_arrow_down</v-icon>
            </v-btn>
        </div>
    </v-toolbar>
</template>

<!--<template>-->
    <!--<v-layout justify-space-around>-->
        <!--<v-icon>mdi-axnchor</v-icon>-->

        <!--<v-icon>mdi-xbox-controller</v-icon>-->

        <!--<v-icon>mdi-watch</v-icon>-->

        <!--<v-icon>mdi-tilde</v-icon>-->

        <!--<v-icon>mdi-tennis</v-icon>-->

        <!--<v-icon>mdi-mouse</v-icon>-->
    <!--</v-layout>-->
<!--</template>-->

<script>

    import axios from 'axios'

    export default {
        name: "GarageRow",
        methods: {
            garageup(){
                function getCookie(cname) {
                    var name = cname + "=";
                    var decodedCookie = decodeURIComponent(document.cookie);
                    var ca = decodedCookie.split(';');
                    for(var i = 0; i <ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) == 0) {
                            return c.substring(name.length, c.length);
                        }
                    }
                    return "";
                }

                var token = "Bearer "+ getCookie("tokenL7TFiZuzFO");
                axios.get('https://homeautomation-proxy.appspot.com/garagedoor/up', {
                    headers: {
                        "Authorization": token
                    }
                }).then((response) => {
                }).catch((error) => {
                    if (error.response.status == '401'){
                        localStorage.removeItem('token');
                        this.$parent.$router.push('/login');
                    }
                });
            },
            garagedown(){
                function getCookie(cname) {
                    var name = cname + "=";
                    var decodedCookie = decodeURIComponent(document.cookie);
                    var ca = decodedCookie.split(';');
                    for(var i = 0; i <ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) == 0) {
                            return c.substring(name.length, c.length);
                        }
                    }
                    return "";
                }

                var token = "Bearer "+ getCookie("tokenL7TFiZuzFO");
                axios.get('https://homeautomation-proxy.appspot.com/garagedoor/down', {
                    headers: {
                        "Authorization": token
                    }
                }).then((response) => {
                }).catch((error) => {
                    if (error.response.status == '401'){
                        localStorage.removeItem('token');
                        this.$parent.$router.push('/login');
                    }
                });
            },
            garagestop(){
                function getCookie(cname) {
                    var name = cname + "=";
                    var decodedCookie = decodeURIComponent(document.cookie);
                    var ca = decodedCookie.split(';');
                    for(var i = 0; i <ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) == 0) {
                            return c.substring(name.length, c.length);
                        }
                    }
                    return "";
                }

                var token = "Bearer "+ getCookie("tokenL7TFiZuzFO");
                axios.get('https://homeautomation-proxy.appspot.com/garagedoor/stop', {
                    headers: {
                        "Authorization": token
                    }
                }).then((response) => {
                }).catch((error) => {
                    if (error.response.status == '401'){
                        localStorage.removeItem('token');
                        this.$parent.$router.push('/login');
                    }
                });
            }

        }
    }
</script>

<style scoped>

</style>